import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { IOperator } from 'src/Interfaces/WellInterface';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';


interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminOperators extends React.Component {
    public props: any;
    public adminStore: any;
    public operatorsDisposer: any; 
    public operators: IOperator[] = [];
    public operatorList: IList;
    public dataService: any = new DataService();
    public MessageStore: MessageStore;
    private UserStore: UserStore;
    
    private tableHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
        { content: 'Group Email', 'class': 'align-left' },
    ];


    public state = {
        formattedoperatorData: this.operatorList,
        operators: this.operators
    };

    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
        this.MessageStore = this.props.stores.MessageStore;
    }

    public componentDidMount() {
        this.adminStore = this.props.stores.AdminStore;

        this.createDisposers();

        this.adminStore.getOperators();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.operatorsDisposer = intercept(this.adminStore, 'operators', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                operators: data
            });

            this.formatDataTable();

            return change;
        });
    }

    public clearDisposers() {
        this.operatorsDisposer();
    }

    public renderoperatorName(operator: IOperator) {
        return(
            <Link to={'/admin/operators/' + operator.id}>{operator.operatorName}</Link>
        );
    }

    public removeOperator = (index: any) => {
        console.log(this.state.operators[index]);
        const areYouSure = confirm(`Deleting the Operator will delete all Prices Lists associated with the Operator.\n\nAre you sure you want to remove operator: ${this.state.operators[index].operatorName}?\n\nPress OK to delete.`);
        if (areYouSure) {
            this.adminStore.deleteOperator(this.state.operators[index])
                .then(
                    (data: any) => {
                        if (data) {
                            this.setState({ isDirty: false }, () => {
                                this.props.history.push('/admin/operators');
                                this.MessageStore.addMessage(
                                    'Operator Successfully Deleted',
                                    'success'
                                );
                                this.adminStore.getOperators();
                            });
                        }
                    });
        }
    }

    public archiveOperator = (index: number) => {
        const operators = this.state.operators[index];
        this.adminStore.archiveOperator(operators)
            .then(
                (data: any) => {
                    if (data) {
                        this.MessageStore.addMessage(
                            'Operator Successfully Archived',
                            'success'
                        );
                        this.adminStore.getOperators();
                    }
                }
            );
    }


    public formatDataTable() {
        const formattedData: any[] = [];
        this.state.operators.map((operator: IOperator, index: number) => {
            const row = [
                {
                    'class': 'align-left',
                    content: this.renderoperatorName.bind(this, operator),
                    sortItem: operator.operatorName,
                    type: 'render'
                },
                {
                    'class': 'align-left',
                    content: operator.groupEmails.map(ge => ge.email).join(', ')
                }
            ];
            formattedData.push(row);
        });

        this.setState({
            formattedoperatorData: {
                headers: this.tableHeaders,
                rows: formattedData
            }
        });
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">Operators</h1>
                    </Col>
                    {
                        this.UserStore.hasPermission('Permissions.Admin.Operators.Create') &&
                        <Col md="6">
                            <Link to="/admin/operators/new">
                                <Button color="primary" className="float-right">
                                    Add New Operator
                                </Button>
                            </Link>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable 
                        list={this.state.formattedoperatorData}
                        onDelete={this.removeOperator}
                        onArchive={this.archiveOperator}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default AdminOperators;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Operators/AdminOperators.tsx